import React from "react";
import { Box } from "@mui/material";
import NumberedTitle from "../../Components/Title";
import DocReviewer from "../../../../DCSTab/DocReviewer";

export default function VendorDataRequirements() {
  return (
    <Box>
      <NumberedTitle number="4" title="Vendor Data Requirements" />
      {/* Show DCS Doc Reviewer filtered to Vendor documents for this plant */}
      <Box mt={2}>
        <DocReviewer plant initialType="Vendor" hideTypeSelector={true} />
      </Box>
    </Box>
  );
}
